import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { getCountryOptions } from "../../api/codelist/codeListsSlice";

const CountrySelect = ({
  name,
  label = "Country",
  control,
  errors,
  readOnly = false,
  disabled,
  onChange,
  helperText = "",
}) => {
  const countryCodeOptions = useSelector(getCountryOptions);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const errorMessage = get(errors, name, {})?.message;

        return (
          <Autocomplete
            {...field}
            id={name}
            data-testid={`${name}-select`}
            options={countryCodeOptions}
            readOnly={readOnly}
            getOptionLabel={(option) =>
              option.code ? `${option.label} (${option.code})` : ""
            }
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid={`${name}-input`}
                label={label}
                error={!!get(errors, name, null)}
                helperText={errorMessage || helperText}
              />
            )}
            isOptionEqualToValue={(option, value) =>
              option.code === value?.code
            }
            onChange={(_, value) => {
              field.onChange(value);
              onChange?.(value);
            }}
            value={field.value || null}
            disabled={disabled}
          />
        );
      }}
    />
  );
};

export default CountrySelect;
